import {$} from '../utils';

// Tab component
const Tab = () => {
    // Looping through each wrapper
    $('.tab', (wrapper) => {
        // All buttons
        const buttons = wrapper.querySelectorAll('.tabBtn a');
        // Each button
        $(buttons, (button) => {
            // // Add event listener
            button.addEventListener('click', (e) => {
                // Prevent default action
                e.preventDefault();
                // Removing active class
                $(buttons).removeClass('active');
                // Adding active class
                $(button).addClass('active');
                // Getting name for the tab
                const name = button.getAttribute('data-tab');
                // All tabs
                const contents = wrapper.querySelectorAll('.tabContent');
                // Removing active class from all tabs
                $(contents).removeClass('active');
                // Adding active class to tab
                $(`#${name}`).addClass('active');
            });
        });
    });
};

// Export component
export default Tab;